import React from 'react';
import classnames from 'classnames';
import { AvatarProps } from '../../types.d';

import styles from '../../Avatar.module.scss';

function SchoolCoachDefault({
  size,
  className,
}: Pick<AvatarProps, 'size' | 'className'>): JSX.Element {
  return (
    <svg
      className={classnames(className, {
        [styles[size]]: size,
      })}
      x="0px"
      y="0px"
      viewBox="0 0 144 144"
      enableBackground="new 0 0 144 144"
    >
      <g id="dice">
        <g id="default_1_">
          <ellipse
            fill="#A6E3F9"
            cx="72"
            cy="71.9980164"
            rx="72"
            ry="71.9980164"
          />
          <g>
            <g>
              <defs>
                <ellipse
                  id="SVGID_39_"
                  cx="72"
                  cy="72.0020142"
                  rx="72"
                  ry="71.9979858"
                />
              </defs>
              <clipPath id="SVGID_2_">
                <use
                  xlinkHref="#SVGID_39_"
                  overflow="visible"
                />
              </clipPath>
              <g
                id="profil_1_"
                clipPath="url(#SVGID_2_)"
              >
                <g>
                  <path
                    fill="#FFE500"
                    d="M102.8176498,150.7133026c-10.7221069,5.57901-23.9722214,1.3947296-29.551239-9.3273926
                    c-5.57901-10.7221069-1.394722-23.9722214,9.3273849-29.5512314
                    c10.7221146-5.5790176,23.972229-1.3947296,29.5512466,9.3273849
                    C117.811203,131.9713745,113.6269684,145.1342926,102.8176498,150.7133026z"
                  />
                  <path
                    fill="#FFE500"
                    d="M108.3966675,125.5206451l-5.3174591,109.1390228H23.2299213L17.912468,125.5206451
                    c-0.4358597-8.7171707,6.5378799-16.12677,15.342205-16.12677h59.9741402
                    C101.8587875,109.3938751,108.8325272,116.7163239,108.3966675,125.5206451z"
                  />
                  <ellipse
                    fill="#FFE500"
                    cx="33.4289703"
                    cy="131.2740173"
                    rx="21.880085"
                    ry="21.880085"
                  />
                  <polygon
                    fill="#FFE500"
                    points="73.3536148,141.38591 104.386734,205.9801483 134.0251312,194.0376587
                    113.8012695,125.1719971"
                  />
                  <polygon
                    fill="#FFE500"
                    points="41.5359344,151.6721649 -7.9776025,171.3730164 -25.2376213,143.0422058 21.5735836,112.8807449"
                  />
                </g>
                <g id="default_7_">
                  <g>
                    <path
                      fill="#0E0E11"
                      d="M75.201828,61.5101967l-5.072113,0.3458099l-2.5360565-34.0060349l5.072113-0.3458099
                      c9.3372192-0.6916199,17.6370163,6.3401089,18.3287048,15.6773281l0,0
                      C91.6861649,52.6341019,84.6543655,60.8185768,75.201828,61.5101967z"
                    />
                    <path
                      fill="#7B4D42"
                      d="M53.8271255,110.439949c1.0460739,6.6250305,7.3224487,11.0708237,13.8603287,9.9375992
                      s11.0708237-7.3224487,9.9375992-13.8603287c-1.0460739-6.6250305-7.3224487-11.070816-13.8603287-9.9375992
                      C57.2268448,97.6256943,52.7810555,103.8149185,53.8271255,110.439949z"
                    />
                    <polygon
                      fill="#7B4D42"
                      points="77.712204,106.5172195 53.8271255,110.439949 49.0326805,81.0630646 49.7300453,80.975914
                      72.9177551,77.1403351"
                    />
                    <path
                      fill="#7B4D42"
                      d="M64.287735,27.7139511l-1.8305855,0.2615032
                      c-11.8553352,1.9177895-19.875145,13.0757618-17.9573555,24.931097l6.6250305,40.3605003l22.4902954-3.6612244
                      c11.2451782-1.8305817,18.916275-12.4655457,17.08564-23.7978745l-3.5740204-21.7929306
                      C85.2961578,33.2929611,75.0970535,25.9705162,64.287735,27.7139511z"
                    />
                    <path
                      fill="#0E0E11"
                      d="M77.7993546,54.8243904c-0.2615051,0-0.4358597-0.1743507-0.4358597-0.4358559
                      s0.1743546-0.4358597,0.4358597-0.4358597l5.7533112-0.4358597c0.2615051,0,0.4358597,0.1743546,0.4358597,0.4358597
                      s-0.1743546,0.4358597-0.4358597,0.4358597L77.7993546,54.8243904L77.7993546,54.8243904z"
                    />
                    <path
                      fill="#0E0E11"
                      d="M62.8058052,55.4346046c-0.2615051,0-0.4358597-0.1743546-0.4358597-0.4358597
                      s0.1743546-0.4358559,0.4358597-0.4358559l6.2763786-0.3487091c0.2614975,0,0.4358521,0.1743546,0.4358521,0.4358597
                      c0,0.2615013-0.1743546,0.4358559-0.4358521,0.4358559L62.8058052,55.4346046L62.8058052,55.4346046z"
                    />
                    <ellipse
                      transform="matrix(0.9984534 -0.0555948 0.0555948 0.9984534 -3.2860293 3.7763009)"
                      fill="#0E0E11"
                      cx="66.2298889"
                      cy="60.9492111"
                      rx="1.6563616"
                      ry="2.0922406"
                    />

                    <ellipse
                      transform="matrix(0.9984534 -0.0555948 0.0555948 0.9984534 -3.2205539 4.5602245)"
                      fill="#0E0E11"
                      cx="80.3523788"
                      cy="60.16436"
                      rx="1.6563616"
                      ry="2.0922406"
                    />
                    <path
                      fill="#0E0E11"
                      d="M86.1450729,36.0895081c0.6108322,2.4869957-1.1489487,4.9300652-3.7013702,5.1385193
                      l-18.0350571,1.4728928c-0.4441452-0.0176468-0.819809,0.3952065-0.7513313,0.8256531
                      c0.3266716,4.2731247-2.7960625,7.9475594-6.98312,8.26054c-4.2731247,0.3266716-7.9475632-2.7960625-8.26054-6.98312
                      c-0.6766014-8.5777969,5.5774612-16.2474289,14.0417023-17.2789917
                      c0.4457397-0.0543232,0.8995018-0.0189495,1.3382034,0.0768299l18.8811836,4.1221848
                      c1.5509567,0.3386097,2.7740021,1.530386,3.1526489,3.0720577L86.1450729,36.0895081z"
                    />
                    <path
                      fill="#0E0E11"
                      d="M49.6321602,30.925375l1.6379623-0.5500546l3.7259712,30.5001907
                      c0.3176117,2.8615723-0.9403572,5.4825058-2.897583,5.7924881l-8.8581543,1.9226456l-2.3962708-19.9317436
                      C39.7599068,39.9084396,43.7127953,32.0333328,49.6321602,30.925375z"
                    />
                    <path
                      fill="#7B4D42"
                      d="M45.109951,69.2077255l4.9687996-0.7845612l-0.784565-4.8815994
                      c-0.4358597-2.702301-2.9638596-4.5329399-5.753315-4.0970802l0,0
                      c-2.702301,0.4358559-4.5329399,2.9638596-4.0970802,5.753315l0,0
                      C39.8796501,67.8129501,42.40765,69.6435852,45.109951,69.2077255z"
                    />
                    <path
                      fill="#FFFFFF"
                      d="M69.1693802,74.4380341c0.3487091,3.3125153,3.3997192,5.6661606,6.7122345,5.3174515
                      s5.6661682-3.3997192,5.3174591-6.7122345L69.1693802,74.4380341z"
                    />
                    <path
                      fill="#0E0E11"
                      d="M73.7563782,34.7228088l-12.1606483,1.6630745
                      c-3.1122818,0.4256744-9.7183838-1.0352707-11.4639511-2.7842979
                      c-1.6942558-1.6976109-4.8578186,0.8205566-3.702198-0.5047684
                      c3.1818047-3.6490688,7.0679016-6.3936844,10.7942162-7.5480328
                      c3.5119476-1.0879402,7.5928764-2.2479401,12.9638023-1.8631573
                      c6.2557907,0.4481754,15.0266266,1.8909206,15.8180389,6.3497047
                      C87.3448105,37.5801506,79.436615,33.9459381,73.7563782,34.7228088z"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SchoolCoachDefault;
